











import { defineComponent } from '@vue/composition-api';
import wave from '../../directives/wave';
import Close from './assets/close.svg';

export default defineComponent({
  name: 'BaseChip',
  directives: {
    wave,
  },
  components: {
    Close,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '',
    },
    isRemovable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const handleClick = (event: Event) => {
      ctx.emit('click', event);
    };
    const handleRemove = () => {
      ctx.emit('remove', props.label);
    };

    return {
      handleClick,
      handleRemove,
    };
  },
});
